import CryptoJS from 'crypto-js';

export function AESDecrypt(base64Source: string, keyString: string): string {
  const blockSize = 4;
  const bytes = CryptoJS.enc.Base64.parse(base64Source);
  const iv = CryptoJS.lib.WordArray.create(bytes.words.slice(0, blockSize));
  const ciphertext = CryptoJS.lib.WordArray.create(
    bytes.words.slice(blockSize),
    bytes.sigBytes - iv.sigBytes
  );
  const key = CryptoJS.enc.Latin1.parse(keyString);
  var decrypted = CryptoJS.AES.decrypt(
    CryptoJS.lib.CipherParams.create({
      ciphertext,
    }),
    key,
    {
      iv,
      mode: CryptoJS.mode.CFB,
      padding: CryptoJS.pad.NoPadding,
    }
  );

  return CryptoJS.enc.Utf8.stringify(decrypted);
}
